import { isEmpty } from 'lodash';
import getCropFormat from './getCropFormat';
import removeNull from './removeNull';

const convertImgixPropsToQueryParams = (
  imgixProps = {},
  src = '',
  isMobileOrTablet = false
) => {
  if (!src) {
    return '';
  }
  if (isEmpty(imgixProps)) {
    return src;
  }
  let finalProps = {
    w: imgixProps.width || null,
    h: imgixProps.height || null,
    ar: imgixProps.ar || null,
    auto: imgixProps.auto || 'format,compress',
    fit: imgixProps.fit || null,
    fill: imgixProps.fill || 'solid',
    'fill-color': imgixProps.fillColor || null,
    'trim-color': imgixProps.trimColor || null,
    'trim-pad': imgixProps.trimPad || null,
    'trim-tol': imgixProps.trimTol || null,
    sizes: imgixProps.sizes || null,
  };
  const cropFormat = imgixProps.enableCrops
    ? imgixProps.cropFormat ||
      getCropFormat({ enableCrops: imgixProps.enableCrops, isMobileOrTablet })
    : null;
  let customCropData = {};
  if (cropFormat && imgixProps.crops?.[cropFormat]) {
    customCropData = imgixProps.crops[cropFormat] || {};
  }
  finalProps = removeNull({
    ...finalProps,
    ...customCropData,
  });
  let finalSrc = `${src}?`;
  Object.keys(finalProps).forEach((imgixQParam, index) => {
    finalSrc += `${index > 0 ? '&' : ''}${imgixQParam}=${
      finalProps[imgixQParam]
    }`;
  });
  return finalSrc;
};

export default convertImgixPropsToQueryParams;
